import { useState } from 'react';

export function useStaffDialogs() {
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  function openStaffDetails(staffMember) {
    setSelectedStaff(staffMember);
    setIsDetailDialogOpen(true);
  }

  function closeStaffDetails() {
    setSelectedStaff(null);
    setIsDetailDialogOpen(false);
  }

  function openCreateDialog() {
    setIsCreateDialogOpen(true);
  }

  function closeCreateDialog() {
    setIsCreateDialogOpen(false);
  }

  return {
    selectedStaff,
    isDetailDialogOpen,
    isCreateDialogOpen,
    openStaffDetails,
    closeStaffDetails,
    openCreateDialog,
    closeCreateDialog,
  };
}
